

import { AnyPoint } from '@brg/api';

/**
 * Displays coords
 */
export default class CoordsDisplay {
    public static fromPoint(point: AnyPoint): string {
        return `${point.latitude}''N ${point.longitude}''E`;
    }
}


import { AnyPoint } from '@brg/api';

/**
 * Displays coords
 */
export default class CoordsDisplay {
    public static fromPoint(point: AnyPoint): string {
        return `${point.latitude}''N ${point.longitude}''E`;
    }
}
